import { faSpinnerThird } from '@fortawesome/pro-solid-svg-icons';
import FontAwesomeIcon from 'Components/Atoms/FontAwesomeIcon/FontAwesomeIcon';
import React from 'react';
import styles from './DropdownLoader.module.sass';

const DropdownLoader = () => {
    return <div className={styles['dropdown__loader']}>
        <FontAwesomeIcon icon={faSpinnerThird} />
        Laden...
    </div>
}

export default React.memo(DropdownLoader);